export const SYMBOL_OMIT = Symbol('omit')
